import { useAtom } from '@reatom/npm-react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styled, { css } from 'styled-components'

import { Numeric } from '@blade/ui-kit'
import { mediaMinTablet } from '@root/shared/ui-kit'

import type { PairModel } from '@root/entities/pair'

type PoolCardMetricsSectionProps = {
  pool: PairModel
}

export const PoolCardMetricsSection: React.FC<PoolCardMetricsSectionProps> = ({
  pool,
}) => {
  const { t } = useTranslation()

  const [liquidityUsd] = useAtom(pool.liquidityUsd)
  const [marketCapUsd] = useAtom(pool.marketCapUsd)
  const [price] = useAtom(pool.price)

  return (
    <Root>
      <Section>
        <Label>{t('pool.liquidity')}</Label>
        <Value>
          <Numeric
            value={liquidityUsd}
            preset="currency-amount-short"
            currency="$"
          />
        </Value>
      </Section>
      <Section>
        <Label>{t('pool.mcap')}</Label>
        <Value>
          <Numeric
            value={marketCapUsd}
            preset="currency-amount-short"
            currency="$"
          />
        </Value>
      </Section>
      <Section>
        <Label>{t('pool.currency-price')}</Label>
        <Value>
          <Numeric
            value={price.priceNative}
            preset="currency-amount-short"
            currency={pool.base.ticker}
          />
        </Value>
      </Section>
    </Root>
  )
}

const Root = styled.section`
  display: grid;
  grid-template-columns: auto auto auto;

  align-items: center;

  border-bottom: 1px solid var(--card-separator-color);
`

const Section = styled.div`
  padding-inline: 16px;
  padding-block: 6px;
  ${mediaMinTablet(css`
    padding-inline: 12px;
    padding-block: 10px;
  `)}

  border-inline-end: 1px solid var(--card-separator-color);
  &:last-child {
    border-inline-end: none;
  }
`

const Label = styled.div`
  color: var(--text-9);
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;

  white-space: nowrap;
`

const Value = styled.div`
  color: var(--text-12);

  font-size: 14px;
  font-weight: 600;
  line-height: 20px;

  margin-top: -3px;
`
